module.exports = __webpack_public_path__ + "static/img/post_10.78d40dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/posts/post_10.png
// module id = 6KfI
// module chunks = 0